import { redirectToSignInPage } from "../api/loginUser";
import { ErrorMessages } from "../constants/Errors";
import { toast } from "react-toastify";

// To avoid triggering multiple toasters at the same time, Toaster is configured with setTimeout and DOM manipulation.

export const returnToaster = (status: string) => {
  if (["NOT_FOUND", "USER_DOES_NOT_EXIST"].includes(status)) {
    return setTimeout(() => {
      if (!document.getElementById(`${1}`)) {
        toast.warning(ErrorMessages.NOT_FOUND, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }, 2000);
  } else {
    return setTimeout(async () => {
      if (!document.getElementById(`${1}`)) {
        toast.error(ErrorMessages.TOKEN_EXPIRED_TOASTER, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      await redirectToSignInPage();
    }, 2000);
  }
};
